<template>
  <div class="container">
    <div class="banBox">
      <router-link
        :to="{ name: 'specificActDetail', query: { sid: sid } }"
        class="homeIcon"
      >
        <img src="../../../static/images/index/home_w.png" />
      </router-link>
      <div
        class="banImg"
        :style="{ backgroundImage: `url(${mobileBanner})` }"
      ></div>
    </div>
    <div class="desc" v-html="specialDesc"></div>
  </div>
</template>
<script>
import { specialDetail } from "@/api/online";
import { getShareData } from "@/utils/share";
export default {
  name: "actIntro",
  data() {
    return {
      sid: "",
      mobileBanner: "",
      specialDesc: "",
    };
  },
  methods: {
    getSpecificActDetail() {
      var that = this;
      var data = {
        SpecialId: this.$route.query.sid,
      };
      specialDetail(data).then((res) => {
        that.mobileBanner = res.Data.MobileBanner;
        that.specialDesc = res.Data.SpecialDesc;
        that.specialDesc = that.specialDesc.replace(
          /<img/g,
          "<img style='width:100% !important;height:auto !important;'"
        );
        that.specialDesc = that.specialDesc.replace(
          /<table/g,
          "<table style='width:100% !important;height:auto !important;'"
        );
        that.specialDesc = that.specialDesc.replace(
          /<ul/g,
          "<ul style='width:100% !important;'"
        );
        that.specialDesc = that.Common.escape2Html(that.specialDesc);
        getShareData(
          window.location.href,
          "2022阿拉丁网上照明展",
          "活动介绍",
        );
      });
    },
  },
  mounted() {
    this.sid = this.$route.query.sid;
    this.getSpecificActDetail();
  },
};
</script>
<style scoped lang="less">
.container {
  .banBox {
    height: 400px;
    position: relative;
    .homeIcon {
      position: absolute;
      z-index: 2;
      top: 12px;
      left: 11px;
      width: 30px;
      height: 30px;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .banImg {
      display: block;
      width: 100%;
      height: 100%;
      background-repeat: no-repeat;
      background-size: 100% auto;
      background-position: center top;
    }
  }
  .desc {
    background: #fff;
    box-sizing: border-box;
    padding: 25px 12px;
    box-sizing: border-box;
    font-size: 14px;
  }
}
</style>
